module.exports = __webpack_public_path__ + "img/a1-7.938d6687.png";